import WidgetContentBox from "./WidgetContentBox";

const index = () => {
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          {/* <!-- Ls widget --> */}
          <div className="ls-widget">
            <div className="tabs-box">
              <WidgetContentBox />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
